import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronRightDouble18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.0607 9L4.53039 3.46967L3.46973 4.53033L7.9394 9L3.46973 13.4697L4.53039 14.5303L10.0607 9ZM15.0607 9L9.53039 3.46967L8.46973 4.53033L12.9394 9L8.46973 13.4697L9.53039 14.5303L15.0607 9Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronRightDouble18.displayName = 'ChevronRightDouble18';
export default ChevronRightDouble18;
